import { Button } from "@faire/web--source/slate/Button";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import brandPortalMarketplace from "@faire/web-api--source/routes/brand-portal/marketplace";
import brandPortalMyShop from "@faire/web-api--source/routes/brand-portal/my-shop/story";
import React, { type JSX } from "react";

import { Bold } from "../common/Bold";
import { LiItem } from "../common/LiItem";

export const ShopAboutSectionIA = () => {
  return (
    <Column>
      <Typography>
        <StrictLocalMsg
          defaultMessage="The about section lets your new and returning customers get to know your brand. Share details like the year you were established, your social media handles, where your products are made, and your location. You can also add brand practice tags and identity tags to your shop, which helps identify your brand and can make it easier for retailers to find your products."
          description={{
            text: "Introduction to the shop about section",
          }}
        />
      </Typography>
      <Spacer height="1x" />
      <Typography>
        <StrictLocalMsg
          defaultMessage="To update your shop about section:"
          description={{
            text: "Header for steps to update the shop about section",
          }}
        />
      </Typography>
      <Spacer height="1x" />
      <ol>
        <LiItem step={1}>
          <Typography>
            <StrictLocalMsg
              defaultMessage="Navigate to the <LinkFormatting>Marketplace</LinkFormatting> tab."
              values={{
                LinkFormatting: MarketplaceLinkFormatting,
              }}
              description={{
                text: "First step to update the shop about section",
              }}
            />
          </Typography>
        </LiItem>
        <Spacer height="1x" />
        <LiItem step={2}>
          <Typography>
            <StrictLocalMsg
              defaultMessage="Select the <LinkFormatting>Shop</LinkFormatting> page."
              values={{
                LinkFormatting: ShopLinkFormatting,
              }}
              description={{
                text: "Second step to update the shop about section",
              }}
            />
          </Typography>
        </LiItem>
        <Spacer height="1x" />
        <LiItem step={3}>
          <Typography>
            <StrictLocalMsg
              defaultMessage="Scroll to <BoldFormatting>Your brand story</BoldFormatting> and <BoldFormatting>About your brand</BoldFormatting> sections."
              values={{
                BoldFormatting,
              }}
              description={{
                text: "Third step to update the shop about section",
              }}
            />
          </Typography>
        </LiItem>
        <Spacer height="1x" />
        <LiItem step={4}>
          <Typography>
            <StrictLocalMsg
              defaultMessage="Make edits and <BoldFormatting>Save</BoldFormatting> any changes."
              values={{
                BoldFormatting,
              }}
              description={{
                text: "Fourth step to update the shop about section",
              }}
            />
          </Typography>
        </LiItem>
      </ol>
    </Column>
  );
};

const ShopLinkFormatting = (chunks: JSX.Element) => (
  <Button variant="tertiary" linkTo={brandPortalMyShop()} target="_blank">
    <Bold>{chunks}</Bold>
  </Button>
);

const MarketplaceLinkFormatting = (chunks: JSX.Element) => (
  <Button variant="tertiary" linkTo={brandPortalMarketplace()} target="_blank">
    <Bold>{chunks}</Bold>
  </Button>
);

const BoldFormatting = (chunks: JSX.Element) => <Bold>{chunks}</Bold>;
